import * as React from "react";
const SvgCheckboxChecked = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 64", fill: "none", stroke: "currentColor", strokeWidth: 6, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M7,7h50v50h-50zM16,16l32,32m-32,0l32,-32" }));
export default SvgCheckboxChecked;
